





import { Vue, Component } from 'vue-property-decorator'
const uuidv1 = require('uuid/v1')
import 'jquery'

export type ErrorHandler = (uuid: string, s: JQueryAjaxSettings, xhr: JQueryXHR, status: string, ex: string) => boolean

@Component
export default class RestClient extends Vue {
    pending!: boolean
    error?: ErrorHandler
    token?: string
    data() {
        return {
            pending: false,
        }
    }
    request(method: string, uri: string, req: any, success: (data: any, status: string, xhr: JQueryXHR) => any, error?: ErrorHandler) {
        let uuid = uuidv1()
        var settings: JQueryAjaxSettings = {
            type: method,
            url: uri,
            contentType: "application/json",
            beforeSend: (xhr: JQueryXHR) => {
                xhr.setRequestHeader('X-REQUEST-ID', uuid)
                if (this.token) {
                    xhr.setRequestHeader("Authorization", 'Bearer ' + this.token)
                }
            },
            success: (data: any, status: string, xhr: JQueryXHR): any => {
                this.pending = false
                success(data, status, xhr)
            } ,
            error: (xhr: JQueryXHR, status: string, ex: string) => {
                this.pending = false
                if (xhr.status == 200) {
                    success(null, status, xhr)
                } else if (error) {
                    if (!error(uuid, settings, xhr, status, ex) && this.error) {
                        this.error(uuid, settings, xhr, status, ex)
                    }
                } else if (this.error) {
                    this.error(uuid, settings, xhr, status, ex)
                }
            },
        }
        if (req) {
            settings.data = JSON.stringify(req)
            settings.dataType = 'json'
        }
        $.ajax(settings)
        this.pending = true
    }
}
